import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { Config } from "../../../config/api.config";

@Injectable({
  providedIn: "root",
})
export class ChangePasswordService {
  constructor(private http: HttpClient) {}

  // changePassword(currentPassword: string, newPassword: string): Observable<any> {
  //   const formData = new FormData();
  //   formData.append("currentPassword", currentPassword);
  //   formData.append("newPassword", newPassword);
  //   return this.http.patch<any>(`${Config.webApiUrl}/v1/person/change-password`, formData);
  // }
  changePassword(currentPassword: string, newPassword: string, confirmPassword: string): Observable<any> {
    return this.http.patch<any>(`${Config.webApiUrl}/v1/auth/change-password`, {
      currentPassword,
      newPassword,
      confirmPassword,
    });
  }
}
